import { Injectable } from '@angular/core';

@Injectable()
export class Commercial {
  public isCommercialDomain: boolean;
  public isCustomerCommercial: boolean;
  public isAccountCommercialPrimary: boolean;

  constructor(isCommercialDomain: boolean, isCustomerCommercial: boolean, isAccountCommercialPrimary) {
    this.isCustomerCommercial = isCustomerCommercial;
    this.isCommercialDomain = isCommercialDomain;
    this.isAccountCommercialPrimary = isAccountCommercialPrimary;
  }

}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/shared/models/commercial.ts